import ApiService from "./api.service";

const MaintenanceService = {
  async maintenance() {
    if (process.env.VUE_APP_MAINTENANCE === "true") {
      return { data: { enabled: true } };
    }

    try {
      return await ApiService.get("maintenance");
    } catch (error) {
      console.log(error);
    }
  },
};

export { MaintenanceService };
